import { render, staticRenderFns } from "./PersonalInfoPanel.vue?vue&type=template&id=3b6e6842&"
import script from "./PersonalInfoPanel.vue?vue&type=script&lang=ts&"
export * from "./PersonalInfoPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports